/**
 * Internal dependencies
 */
import Request from "./lib/util/request";
import Layout from "./lib/layout";
import Widget from "./lib/widget";
import WidgetType from "./lib/widget-type";
import requestHandler from "./lib/util/fetch-request";
import Authentication from "./lib/authentication";
import Preferences from "./lib/preferences";
import CubeJs from "./lib/cube-js";
import Ai from "./lib/ai";
import Marketing from "./lib/marketing";
import Location from "./lib/location";
import Partner from "./lib/partner";

export function VDCOM(token) {
  if (!(this instanceof VDCOM)) {
    return new VDCOM(token);
  }

  if (token) {
    this.token = token;
  } else {
    this.loadToken();
  }

  this.request = function (params, fn) {
    params = params || {};
    // token is optional
    if (this.token) {
      params.authToken = this.token;
    }

    return requestHandler(params, fn);
  };

  // Add Req instance
  this.req = new Request(this);
}

VDCOM.prototype.authentication = function () {
  return new Authentication(this);
};

VDCOM.prototype.layout = function (id) {
  return new Layout(id, this);
};

VDCOM.prototype.preferences = function () {
  return new Preferences(this);
};

VDCOM.prototype.widget = function (id) {
  return new Widget(id, this);
};

VDCOM.prototype.widgetType = function () {
  return new WidgetType(this);
};

VDCOM.prototype.loadToken = function () {};

VDCOM.prototype.cubeJs = function () {
  return new CubeJs(this);
};

VDCOM.prototype.ai = function () {
  return new Ai(this);
};

VDCOM.prototype.marketing = function () {
  return new Marketing(this);
};

VDCOM.prototype.location = function (id) {
  return new Location(id, this);
};

VDCOM.prototype.partner = function () {
  return new Partner(this);
};

VDCOM.Request = Request;

let vdcom;

if (!vdcom) {
  vdcom = VDCOM();
}

export default vdcom;
